import { cn } from "@/shared/lib/utils"
import { RANGES, type StatisticsRange } from "./statistics.config"

interface RangePickerProps {
  value: StatisticsRange
  onChange: (range: StatisticsRange) => void
}

export function RangePicker({ value, onChange }: RangePickerProps) {
  return (
    <div className="flex gap-1 rounded-lg border border-border bg-muted/40 p-1">
      {RANGES.map((range) => {
        const selected = range.value === value
        return (
          <button
            key={range.value}
            type="button"
            onClick={() => onChange(range.value)}
            className={cn(
              "flex-1 rounded-md px-2 py-1.5 text-xs font-medium transition-colors",
              selected
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {range.label}
          </button>
        )
      })}
    </div>
  )
}
